import axios from '../../../requesters/axios';
import {SUCCESSFUL_FETCHED_SERVICES} from '../../../actionTypes/service';
import { addToCart as addToShoppingCart, addObservationsToCartItem } from '../../../components/shoppingCart/actions';
import { apiErrorHandler } from '../../../errors';

export const SHOW_MODAL_ADDITIONAL_DATA = 'SHOW_MODAL_ADDITIONAL_DATA';
export const SHOW_INFORMATION_SERVICE = 'SHOW_INFORMATION_SERVICE';
export const CHANGE_CONTENT = 'CHANGE_CONTENT';
export const ADD_OBSERVATIONS = 'ADD_OBSERVATIONS';
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const FETCH_ADDITIONAL_SERVICES_SUCCESS = 'FETCH_ADDITIONAL_SERVICES_SUCCESS';
export const RENDER_APPOINTMENT_OR_BUDGET = 'RENDER_APPOINTMENT_OR_BUDGET';

export function showInfo(selectedService) {
  return (dispatch) => {
    dispatch({
      type: SHOW_INFORMATION_SERVICE,
      payload: {
        selectedService,
      },
    });
  };
}

export function changeContent(content) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_CONTENT,
      payload: {
        router: 'content',
        content,
      },
    });
  };
}

export function addObservations(element, observations) {
  return (dispatch) => {
    dispatch(addObservationsToCartItem(element, observations));
    dispatch(changeContent(null));
  };
}

export function addToCart(element, makeObject, car = {}) {
  return (dispatch) => {
    dispatch(addToShoppingCart(element, makeObject, car));
    dispatch({
      type: ADD_OBSERVATIONS,
      payload: {
        router: 'observations',
        element,
      },
    });
  };
}

export function showModal(isVisible) {
  return dispatch => dispatch({
    type: SHOW_MODAL_ADDITIONAL_DATA,
    payload: { show: isVisible }
  })
}

export function searchServices(query) {
  return (dispatch) => {
    axios.get(`/services?name=${query}&clientService=true`)
      .then((response) => {
        dispatch({
          type: SUCCESSFUL_FETCHED_SERVICES,
          payload: {
            services: response.data,
            isLoading: false,
          }
        })
      })
      .catch(apiErrorHandler);
  }
}

export function fetchAdditionalServices() {
  return (dispatch) => {
    axios.get('/services/search/additionalServices')
      .then((response) => {
        dispatch({
          type: FETCH_ADDITIONAL_SERVICES_SUCCESS,
          payload: {
            additionalServices: response.data,
          }
        })
      })
      .catch(apiErrorHandler);
  }
}

export function switchAppointmentOrBudget(renderAppointmentOrBudget) {
  return (dispatch) => {
    dispatch({
      type: RENDER_APPOINTMENT_OR_BUDGET,
      payload: {
        renderAppointmentOrBudget: renderAppointmentOrBudget,
      }
    });
  };
}


// WEBPACK FOOTER //
// ./src/workflow/checkout/services/actions.js